import React, { forwardRef, useState, useEffect } from "react";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import "./FeatureCard.css";

const FeatureCard = forwardRef(function FeatureCard(
  {
    title,
    description,
    gradientRotation = "90deg",
    imageUrl,
    className = "",
    overlayClass = "",
  },
  ref
) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      setLoaded(true);
      return;
    }
    const img = new window.Image();
    img.src = imageUrl;
    img.onload = () => setLoaded(true);
  }, [imageUrl]);

  return (
    <div
      ref={ref}
      className={`feature-card-bg ${className} ${
        loaded ? "bg-loaded" : "bg-loading"
      }`}
      style={{
        transition: "background-image 0.5s ease-in, background-color 0.3s",
        backgroundColor: !loaded ? "#192a3a" : undefined,
      }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          className={`feature-card-img${loaded ? " loaded" : ""}`}
          loading="lazy"
          decoding={"async"}
          style={{
            display: loaded ? "block" : "none",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />
      )}
      <div
        className={overlayClass}
        style={{
          background: `linear-gradient(${gradientRotation}, #192a3a 45%, #192a3a99 86%, #192a3a80 90%, #192a3a73)`,
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="text">
          <div className="icon-container">
            <LiaFileInvoiceSolid size={40} />
          </div>
          <h3 className="card-title">{title}</h3>
          <p className="card-description">{description}</p>
        </div>
      </div>
    </div>
  );
});

export default FeatureCard;
